export default "__VITE_ASSET__DE6tY6aQ__"